module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header bg"
  }, [_c('div', {
    staticClass: "header-top"
  }, [_c('div', {
    staticClass: "header-top-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "header-top-r"
  }, [_c('div', {
    staticClass: "pc-nav"
  }, [_c('div', {
    staticClass: "pc-nav-flex"
  }, [_c('nav', [_c('ul', {
    staticClass: "nav"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "nav-active",
      "to": "/home"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav1")))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "nav-active",
      "to": "/content"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav2")))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "nav-active",
      "to": "/partner"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav3")))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "nav-active",
      "to": "/about"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav4")))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "i18"
  }, [_c('span', {
    class: {
      'i18-hidden': this.$i18n.locale == 'en'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeLanuageZh.apply(null, arguments)
      }
    }
  }, [_vm._v("中文")]), _vm._v(" "), _c('span', [_vm._v("|")]), _vm._v(" "), _c('span', {
    class: {
      'i18-hidden': this.$i18n.locale == 'zh'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeLanuageEn.apply(null, arguments)
      }
    }
  }, [_vm._v("English")])])])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-nav"
  }, [_c('div', {
    staticClass: "mobile-nav-icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showMobileNav.apply(null, arguments)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "viewBox": "0 0 60 60",
      "preserveAspectRatio": "none"
    }
  }, [_c('g', {
    attrs: {
      "id": "icon-grid",
      "fill": "#fff"
    }
  }, [_c('rect', {
    attrs: {
      "x": "4.5",
      "y": "2.5",
      "width": "50",
      "height": "5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "4.5",
      "y": "22.5",
      "width": "50",
      "height": "5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "4.5",
      "y": "42.5",
      "width": "50",
      "height": "5"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "icon-cross"
    }
  }, [_c('line', {
    attrs: {
      "x1": "4.5",
      "y1": "55.5",
      "x2": "54.953",
      "y2": "5.046"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "54.953",
      "y1": "55.5",
      "x2": "4.5",
      "y2": "5.047"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "mobile-nav-block",
    style: ({
      height: _vm.mobileNavH
    })
  }, [_c('div', {}, [_c('ul', {
    staticClass: "mobile-nav-ul"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/home"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav1")))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/content"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav2")))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/partner"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav3")))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/about"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav4")))]), _vm._v(" "), _c('li', [_c('span', {
    class: {
      'i18-hidden': this.$i18n.locale == 'en'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeLanuageZh.apply(null, arguments)
      }
    }
  }, [_vm._v("中文")]), _vm._v(" "), _c('span', [_vm._v("|")]), _vm._v(" "), _c('span', {
    class: {
      'i18-hidden': this.$i18n.locale == 'zh'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeLanuageEn.apply(null, arguments)
      }
    }
  }, [_vm._v("English")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mobile-nav-close-icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.hiddenMobileNav.apply(null, arguments)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "viewBox": "0 0 60 60",
      "preserveAspectRatio": "none"
    }
  }, [_c('g', {
    attrs: {
      "id": "icon-cross"
    }
  }, [_c('line', {
    attrs: {
      "x1": "4.5",
      "y1": "55.5",
      "x2": "54.953",
      "y2": "5.046"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "54.953",
      "y1": "55.5",
      "x2": "4.5",
      "y2": "5.047"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-top-l"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "https://static3.freshin.online/sku/MhU6EcFPoRN5Ppnb9Wg-1-KU5bI%3D",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61a25d3f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/headers.vue
// module id = 46
// module chunks = 0